// @flow
import { connect } from 'react-redux';
import PaymentListViewRow from './PaymentListViewRow';
import {
  paymentMeanCharacteristicsByOuidSelector,
  paymentMeanTypeByOuidSelector,
} from '../../../modules/Customer/selectors';

const mapStateToProps = (state, ownProps) => ({
  paymentMeanType: paymentMeanTypeByOuidSelector(state, ownProps.paymentMeanOuid),
  paymentMeanCharacteristics: paymentMeanCharacteristicsByOuidSelector(state, ownProps.paymentMeanOuid),
});

export default connect(mapStateToProps)(PaymentListViewRow);
